import React, {Fragment} from "react";
import ImageRadioPicker from "../../../components/ImageRadioPicker";
import PropTypes from "prop-types";
import imageT2 from '../../../images/situation/hengtype/T2.jpg';
import imageL2 from '../../../images/situation/hengtype/L2.jpg';
import imageH2 from '../../../images/situation/hengtype/H2.jpg';
import imageT3 from '../../../images/situation/hengtype/T3.jpg';
import imageL3 from '../../../images/situation/hengtype/L3.jpg';
import imageHT3 from '../../../images/situation/hengtype/HT3.jpg';
import imageLT3 from '../../../images/situation/hengtype/LT3.jpg';
import {HengType} from "../../../Model";
import PickerInfoBox from "../../../components/PickerInfoBox";
import {validateHangPoints, validateKlampen} from "../../../util/Validator";

HengtypeWindow.propTypes = {
    currentValue: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    luiktype: PropTypes.string.isRequired,
    hoogte: PropTypes.string.isRequired,
}
export default function HengtypeWindow(props) {
    return <Fragment>
        <div className="phone-page-middle">
            <div className="phone-situation-title">
                Hier kunt u aangeven welk hengtype uw situatie heeft.<br/>
            </div>
            <div className="phone-pick-body">
                <ImageRadioPicker onSelect={props.onChange}
                                  current={props.currentValue}
                                  value={HengType.T2}
                                  image={imageT2}
                                  medium/>
                <ImageRadioPicker onSelect={props.onChange}
                                  current={props.currentValue}
                                  value={HengType.L2}
                                  image={imageL2}
                                  medium/>
                <ImageRadioPicker onSelect={props.onChange}
                                  current={props.currentValue}
                                  value={HengType.H2}
                                  image={imageH2}
                                  medium/>
                <ImageRadioPicker onSelect={props.onChange}
                                  current={props.currentValue}
                                  value={HengType.T3}
                                  image={imageT3}
                                  medium/>
                <ImageRadioPicker onSelect={props.onChange}
                                  current={props.currentValue}
                                  value={HengType.L3}
                                  image={imageL3}
                                  medium/>
                <ImageRadioPicker onSelect={props.onChange}
                                  current={props.currentValue}
                                  value={HengType.HT3}
                                  image={imageHT3}
                                  medium/>
                <ImageRadioPicker onSelect={props.onChange}
                                  current={props.currentValue}
                                  value={HengType.LT3}
                                  image={imageLT3}
                                  medium/>
            </div>
        </div>

        <PickerInfoBox
            options={[
                {value: HengType.T2, text: "Twee T hengen"},
                {value: HengType.L2, text: "Twee staarthengen"},
                {value: HengType.H2, text: "Twee hoek hengen"},
                {value: HengType.T3, text: "Drie T hengen"},
                {value: HengType.L3, text: "Drie staarthengen"},
                {value: HengType.HT3, text: "Twee hoek hengen en één T geheng"},
                {value: HengType.LT3, text: "Twee staartgengen en één T geheng"},
            ]}
            current={props.currentValue}
            warnings={[
                ...validateKlampen(-1, props.currentValue, props.luiktype, true),
                ...validateHangPoints(-1, props.currentValue, props.hoogte, true)
            ]}
            sticky
        />
    </Fragment>
}